module.exports = __webpack_public_path__ + "img/thumbnail_Markhor_f_leucistic.401ed10d.png";